import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const TimeRewindHourGlassIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      width="57.473"
      height="54.861"
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 8 57.473 54.861"
      {...props}
    >
      <g id="Time_RewindHourglass" transform="translate(30.188 -4.852) rotate(45) scale(1.23)">
        <path id="Path_440" data-name="Path 440" d="M28.907,1.107a21.923,21.923,0,0,1,15.1,20.7v.6l2.3-2.3,1.4,1.4-4.7,4.7-4.7-4.7,1.4-1.4,2.3,2.3v-.6a20.057,20.057,0,1,0-1,6.4l1.9.6a21.994,21.994,0,1,1-14-27.7Z" transform="translate(53.461 30.985) rotate(150)" />
        <path id="Path_441" data-name="Path 441" d="M19,9.3,4.6,23.7,9,28.1l2-2,2.6,2.6H19v5.4l2.6,2.6-2,2L24,43.1,38.4,28.7,34,24.3l-2,2-2.6-2.6H24V18.3l-2.6-2.6,2-2ZM9,25.3,7.4,23.7,19,12.1l1.6,1.6Zm25,1.8,1.6,1.6L24,40.3l-1.6-1.6Zm-12-8v6.6h6.6l2,2L23,35.3l-2-2V26.7H14.4l-2-2L20,17.1Z" transform="translate(2.828 -2.828)" />
      </g>
    </StyledSVGIcon>
  );
};